import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { leadList, logOutApi, countryList, listMarketingTeam, assignMarketingTeam, createProvider, leadsClose, leadsReopen, leadsComplete, deleteLeads } from "../../../../Context/api";
import axios from "axios";
import { commonMessage, statusCodes } from "../../../../Constants/generalConfig";
import { toast } from "react-toastify";

const UseLeadList = () => {
    const [listData, setListData] = useState([]);
    const [teamListData, setTeamListData] = useState([]);
    const [spinner, setSpinner] = useState(false)
    const [show, setShow] = useState(false)
    const [filter, setFilter] = useState({
        country: '',
        leadNumber: '',
        searchText: '',
        provider: '',
        deleted: ''
    })
    const [countryData, setCountryData] = useState([])
    const [leadId, setLeadId] = useState('')
    const [leadDetails, setLeadDetails] = useState([])
    const [assignMember, setAssignMember] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState('')
    const PER_PAGE = 10
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((pre) => ({
            ...pre,
            [name]: value
        }))
    }
    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }

    useEffect(() => {
        list()
    }, [page])
    useEffect(() => {
        countryListData()
    }, [])

    const list = () => {
        setSpinner(true)
        const data = {
            page: page,
            count: PER_PAGE,
            searchText: filter.searchText,
            leadNumber: filter.leadNumber,
            country: filter.country,
            isProvider: filter.provider === 'true',
            isDelete: filter.deleted === 'true'
        }
        axios.post(leadList(), data,).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setListData(resp.data.data);
                setSpinner(false)
                setCount(resp.data.totalCount);
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            } else {
                setListData([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })

    };
    const countryListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            isActive: true,
            searchText: '',
            page: 1,
            count: 100
        }

        axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)

            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setCountryData([])
                setSpinner(false)
                if (page > 1) {
                    setPage(page - 1)
                }
            }
        })
    }
    const teamList = () => {
        const data = {
            page: 1,
            count: 100,
            createdbyId: adminData?.userId
        }
        axios.post(listMarketingTeam(), { ...data },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setTeamListData(resp.data.data);
            }
            else {
                setTeamListData([])
            }
        })

    };
    const assignTeam = () => {
        if (!assignMember?.length) return toast.warn('Please select team member')
        const data = {
            marketingTeamId: assignMember,
            createdbyId: adminData?.userId,
            leadId: leadDetails?._id
        }
        setSpinner(true)
        axios.post(assignMarketingTeam(), { ...data },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setShow(false)
                setSpinner(false)
                setAssignMember([])
                setLeadDetails([])
                list()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        })
    };

    const convertToProvider = () => {
        setSpinner(true)
        axios.post(createProvider(), { leadId: leadId, createdbyId: adminData?.userId },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                list()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        })
    };
    const closeLead = () => {
        setSpinner(true)
        axios.post(leadsClose(), { leadId: leadId, createdbyId: adminData?.userId },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                list()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        })
    };
    const completeLead = () => {
        setSpinner(true)
        axios.post(leadsComplete(), { leadId: leadId, createdbyId: adminData?.userId },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                list()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        })
    };
    const reopenLead = () => {
        setSpinner(true)
        axios.post(leadsReopen(), { leadId: leadId, createdbyId: adminData?.userId },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                list()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        })
    };
    const deleteLead = () => {
        setSpinner(true)
        axios.post(deleteLeads(), { leadId: leadId, isDelete: true },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                list()
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)

            }
        })
    };
    return {
        list,
        setPage,
        setShow,
        navigate,
        teamList,
        closeLead,
        setLeadId,
        reopenLead,
        assignTeam,
        deleteLead,
        completeLead,
        handleChange,
        setLeadDetails,
        setAssignMember,
        convertToProvider,
        teamListData,
        assignMember,
        countryData,
        PER_PAGE,
        listData,
        spinner,
        filter,
        show,
        page,
        count,
    }
}

export default UseLeadList